<template>
  <div class="landing-faq">
    <aos-vue placement="top-bottom" animation="fade-up" :duration="800" :once="true">
      <div class="landing-faq__query">
        Остались вопросы?
      </div>
    </aos-vue>
    <aos-vue placement="top-bottom" animation="fade-up" :duration="800" :once="true">
      <div class="landing-faq__title">
        FAQ и документы
      </div>
    </aos-vue>
    <div class="landing-faq__content">
      <aos-vue placement="top-bottom" animation="fade-up" :duration="800" :once="true">
        <div class="landing-faq__accordion">
          <div v-for="item, index in accordion" :key="index" class="landing-faq__line">
            <div class="landing-faq__question" @click="openAccordion">
              <span v-html="item.question">
              </span>
              <svg>
                <use xlink:href="@/assets/images/sprites.svg#arrow-down"></use>
              </svg>
            </div>
            <div class="landing-faq__answer">
              <span v-html="item.answer">
              </span>
            </div>
          </div>
        </div>
      </aos-vue>
      <aos-vue placement="top-bottom" animation="fade-up" :duration="800" :once="true">
        <div class="landing-faq__document">
          <a v-for="document, index in documents" :key="index" class="landing-faq__label" :href="document.url"
            target="_blank">
            <span>
              {{ document.label }}
            </span>
            <svg>
              <use xlink:href="@/assets/images/sprites.svg#icon-download"></use>
            </svg></a>
        </div>
      </aos-vue>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Faq',
  methods: {
    openAccordion(event) {
      event.target.closest('.landing-faq__line').classList.toggle('is-show');
    }
  },
  mounted() {
  },
  data() {
    return {
      accordion: [
        {
          question: 'Что такое Подписка на автомобиль?',
          answer: 'Автоподписка — это долгосрочная аренда с возможностью выкупа. Вы платите фиксированную сумму в месяц, а все расходы (КАСКО, ОСАГО, налоги, ТО) уже включены. В конце подписки можно:<br/>' +
            '✔ Продлить договор<br/>' +
            '✔ Выбрать другой автомобиль<br/>' +
            '✔ Выкупить авто по заранее зафиксированной цене<br/><br/>' +
            '🚗 Без аванса, без кредита, без лишних забот – просто водите!',
        },
        {
          question: 'Когда выгодна подписка?',
          answer: 'На первый взгляд может показаться, что подписка на автомобиль обходится дороже, чем его покупка или кредит. Но не стоит сразу делать выводы. Подписка предлагает возможность пользоваться автомобилем, не владея. Давайте разберемся, сколько на самом деле стоит владение собственным автомобилем.<br/><br/>' +
            'Основные расходы включают в себя покупку машины. Даже если вы покупаете ее за свои деньги, это не означает, что у вас нет дополнительных затрат. Ведь эти деньги можно было бы использовать иначе, например, вложить их в бизнес, депозиты, ценные бумаги или инвестиции, что привело бы к потенциальной прибыли. Кроме того, при продаже автомобиля важно учитывать его стоимость на вторичном рынке, будь то через трейд-ин или продажу самостоятельно.<br/><br/>' +
            'Значительные расходы - страхование. Новый автомобиль требует как обязательного ОСАГО, так и КАСКО. Покупка зимнего комплекта шин также существенный расход.<br/><br/>' +
            'Периодические дополнительные расходы - налоги, регистрацию/снятие с учета, техническое обслуживание, карты помощи на дорогах и другие расходы. Эти расходы могут набежать на значительную сумму ежегодно.<br/><br/>' +
            'Оценить точную стоимость владения автомобилем сложно, но примерную - возможно. Все эти расходы и заботы ложатся на вас.<br/><br/>' +
            'Подписка на автомобиль предлагает удобство использования без необходимости владения им.<br/><br/>' +
            'Расходы же на топливо, оплату дорог, штрафы и парковку не зависят от способа приобретения автомобиля и одинаковы во всех случаях.',
        },
        // {
        //   question: 'Как оформить подписку?',
        //   answer: '1️⃣ Выберите автомобиль, который вам понравился, и нажмите «Забронировать».<br/>' +
        //     '2️⃣ Пройдите проверку документов и дождитесь одобрения (обычно занимает 15 минут).<br/>' +
        //     '3️⃣ Оплатите первый месяц подписки.<br/>' +
        //     '4️⃣ Заберите авто в дилерском центре и наслаждайтесь поездками.<br/><br/>' +
        //     '🚗 Не нашли нужный автомобиль? Его можно заказать! Просто оставьте заявку на сайте или позвоните нам.',
        // },
        {
          question: 'Кто может оформить подписку?',
          answer: 'Условия подписки: минимальный возраст 25 лет, водительский стаж от 3 лет, гражданство РФ.',
        },
        {
          question: 'Можно ли оформить подписку на компанию (юридическое лицо)?',
          answer: 'Подписку также можно оформить на юридическое лицо. Для этого оставьте заявку, и наш специалист свяжется с вами для уточнения деталей и запроса документов для одобрения сделки.',
        },
        {
          question: 'По какой причине мне могут отказать в подписке?',
          answer: 'Все клиенты проходят комплексную проверку. Мы не сообщаем точную причину отказа, так как не храним персональные данные. Наиболее частые причины отказа: загрузка неверных или недействительных документов, непогашенная задолженность свыше 10 000 рублей, низкий кредитный рейтинг.<br/><br/>' +
            'Если вы считаете, что отказ был ошибочным, напишите нам на <a href="mailto:help@autopodpiska.ru">help@autopodpiska.ru.</a>',
        },
        {
          question: 'Как записаться на ТО/шиномонтаж? Куда обращаться при ДТП?',
          answer: 'Для записи на сервисное обслуживание, сезонный шиномонтаж, а также в случае ДТП позвоните на нашу горячую линию: <a href="tel:+7-495-126-90-58">+7-495-126-90-58.</a>',
        },
        {
          question: 'На какой срок можно взять автомобиль в подписку?<br>Есть ли ограничения по пробегу?',
          answer: 'Подписка подразумевает получение автомобиля на срок от 6 до 12 месяцев. Максимально допустимый пробег составляет от 10 000 км до 30 000 км. При превышении указанного пробега взимается плата за каждый дополнительный километр согласно условиям договора.',
        },
        {
          question: 'Могу ли я выехать на автомобиле по подписке за пределы зоны эксплуатации?',
          answer: 'Выезд за пределы указанной территории эксплуатации в России возможен после дополнительного согласования. Для этого свяжитесь с нами по телефону <a href="tel:8 (495) 126-17-36">8 (495) 126-17-36</a> или напишите нам на <a href="mailto:help@autopodpiska.ru">help@autopodpiska.ru.</a>',
        },
        {
          question: 'Кто оплачивает штрафы?',
          answer: 'Самостоятельно оплачивать штрафы не нужно! Мы оплачиваем их в государственные органы с применением всех возможных скидок. При этом суммы штрафов автоматически списываются с карты, привязанной при регистрации (если штраф не был оспорен вами в течение трех дней).',
        },
        {
          question: 'История Пользовательских соглашений',
          answer: '<a href="/public/documents/contract_until_30april2024.pdf" target="_blank">До 6 мая 2024 года</a><br/><a href="/public/documents/contract_from_30april2024.pdf" target="_blank">С 6 мая 2024 до 24 октября 2025</a>',
        },
      ],
      documents: [
        {
          label: 'Актуальное пользовательское соглашение',
          url: '/public/documents/contract (1).pdf',
        }
      ],
    };
  }
};
</script>
